<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import EventBus from '@/utils/event-bus';

moment.locale('zh-cn');
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    };
  },
  created() {
    // EventBus.$on('ExpiredAuthorization', () => {
    //   this.$router.replace({
    //     path: '/login',
    //     query: {
    //       redirect: this.$route.path,
    //     },
    //   });
    // });
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
  background: #f5f7fa;
}

@font-face {
  font-family: "iconfont";
  /* Project id 4040207 */
  src: url("//at.alicdn.com/t/c/font_4040207_begp5tla3sb.woff2?t=1682576622057") format("woff2"),
    url("//at.alicdn.com/t/c/font_4040207_begp5tla3sb.woff?t=1682576622057") format("woff"),
    url("//at.alicdn.com/t/c/font_4040207_begp5tla3sb.ttf?t=1682576622057") format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 14px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ant-drawer.ant-drawer-right {
  left: auto !important;
}
</style>
